export const selectCart = (state) => state.cart;